import { UserStore } from "../../../plugins/auth/model/UserStore";
export class SubscriptionExpirationQualifier {
    constructor() {
        this.key = "SubscriptionExpiration";
    }
    process() {
        const user = UserStore.getUser();
        if (!user || !Array.isArray(user.Subscriptions) || user.Subscriptions.length === 0) {
            return "";
        }
        //  Get latest expiration date
        const latestSubscription = this.getLatestSubscription(user.Subscriptions);
        if (!(latestSubscription === null || latestSubscription === void 0 ? void 0 : latestSubscription.ExpirationDate)) {
            return "";
        }
        return this.toUtcString(latestSubscription.ExpirationDate);
    }
    getLatestSubscription(subscriptions) {
        return subscriptions.reduce((latest, current) => {
            const currentDate = new Date((current === null || current === void 0 ? void 0 : current.ExpirationDate) || 0).getTime();
            const latestDate = new Date((latest === null || latest === void 0 ? void 0 : latest.ExpirationDate) || 0).getTime();
            return currentDate > latestDate ? current : latest;
        }, subscriptions[0]);
    }
    toUtcString(date) {
        try {
            return new Date(date).toISOString();
        }
        catch (_a) {
            return "";
        }
    }
}
